module.exports = __webpack_public_path__ + "static/media/2DGACM4.0ecc7a1f.jpg";